import { atom } from "recoil";

export const refreshGlobal = atom ({
    key: "refreshGlobal",
    default: 0,
});